import { fromJS, Map as ImmutableMap } from 'immutable';
import type { Reducer } from 'redux';

import type { TypedMap } from 'utils/typed-map';

import { ADD, ADD_MULTIPLE, REMOVE } from './constants';
import type VolunteerTime from './model';

export type VolunteerTimeMap = ImmutableMap<string, VolunteerTime>;

export type VolunteerTimeState = TypedMap<{
  volunteerTimes: VolunteerTimeMap;
}>;

export const initialState: VolunteerTimeState = fromJS({
  volunteerTimes: ImmutableMap(),
});

const volunteerTimeReducer: Reducer = (state = initialState, action): VolunteerTimeState => {
  switch (action.type) {
    case ADD:
      return state.set(
        'volunteerTimes',
        state.get('volunteerTimes').set(action.volunteerTime.id, action.volunteerTime)
      );

    case ADD_MULTIPLE:
      return state.set('volunteerTimes', state.get('volunteerTimes').merge(action.volunteerTimes));

    case REMOVE:
      return state.set('volunteerTimes', state.get('volunteerTimes').remove(action.id));

    default:
      return state;
  }
};
export default volunteerTimeReducer;
